import ability from './ability'

export const canNavigate = to => {
    return to.matched.some(route => {
         const ability2 = ability.can(route.meta.action || 'read', route.meta.resource)
         return ability2
    })
}
export const _ = undefined
